<template>
  <div class="mod-list">
    <a-table :columns="columns" :data-source="dataBySort" row-key="index" :locale="locale" :pagination="data.pagination" :loading="loading" @change="onChange">
      <a slot="couponCode" slot-scope="text, record" @click.prevent="onShowDetail(record.couponCode)">{{ text }}</a>
      <span slot="type" slot-scope="text">{{ text | cardType }}</span>
      <span slot="preferentialType" slot-scope="text">{{ text | couponType }}</span>
      <span slot="preferentialValue" slot-scope="text, record">{{ record.preferentialType === 0 ? `${text}元` : `${text*10}折` }}</span>
      <span slot="maxAmount" slot-scope="text">{{ text }}元</span>
      <span slot="validity" slot-scope="text, record">{{ record.startDate }} - {{ text }}</span>
      <span slot="status" slot-scope="text">{{ text | couponStatus }}</span>
      <router-link slot="orderNo" slot-scope="text, record" :to="goToOrderDetail(record)" target="_blank">{{ text }}</router-link>
    </a-table>
  </div>
</template>

<script>
import { cardType, couponType, couponStatus } from '@/filters/coupon'
import _ from 'lodash'

const columns = [
  {
    dataIndex: 'indexNew',
    title: '序号',
    scopedSlots: { customRender: 'indexNew' }
  },
  {
    dataIndex: 'couponCode',
    title: '卡券号',
    scopedSlots: { customRender: 'couponCode' }
  },
  {
    dataIndex: 'type',
    title: '卡券类型',
    scopedSlots: { customRender: 'type' }
  },
  {
    dataIndex: 'preferentialType',
    title: '优惠类型',
    scopedSlots: { customRender: 'preferentialType' }
  },
  {
    dataIndex: 'preferentialValue',
    title: '面值',
    scopedSlots: { customRender: 'preferentialValue' }
  },
  {
    dataIndex: 'maxAmount',
    title: '最大优惠金额',
    scopedSlots: { customRender: 'maxAmount' }
  },
  {
    dataIndex: 'endDate',
    title: '优惠券有效期',
    scopedSlots: { customRender: 'validity' }
  },
  {
    dataIndex: 'status',
    title: '状态',
    scopedSlots: { customRender: 'status' }
  },
  {
    dataIndex: 'orderNo',
    title: '订单号',
    scopedSlots: { customRender: 'orderNo' }
  },
  {
    dataIndex: 'useTime',
    title: '使用时间'
  }
]

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {
          list: [],
          pagination: {
            current: 1,
            pageSize: 10,
            total: 0
          }
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataBySort () {
      const list = _.orderBy(this.data.list, ({ useDate }) => useDate || '', ['desc'])
      list.forEach((element, index) => {
        element.indexNew = index + 1
      })
      return list
    }
  },
  data () {
    return {
      columns,
      locale: {
        emptyText: '暂无数据'
      }
    }
  },
  methods: {
    onChange (pagination) {
      this.$emit('change', pagination)
    },
    onShowDetail (couponCode) {
      this.$emit('detail', couponCode)
    },
    goToOrderDetail (record) {
      let detailUrl = ''
      const { orderNo, type } = record
      if (type === 1) {
        if (String(orderNo).length === 20) {
          detailUrl = `/order/detail?orderNo=${orderNo}`
        } else {
          detailUrl = `/order/v2/detail?orderNo=${orderNo}`
        }
      } else if (type === 2) {
        // TODO: 未区分随票还是单独辅营
        if (String(orderNo).length === 20) {
          detailUrl = `/ancillary/subDetail?subOrderNo=${orderNo}`
        } else {
          detailUrl = `/ancillary/v2/subDetail?subOrderNo=${orderNo}`
        }
      }
      return detailUrl
    }
  },
  filters: {
    cardType,
    couponType,
    couponStatus
  }
}
</script>
